import {ACTIVE_GLOW} from '../configs/activeGlow';

const TWO_PI = Math.PI * 2;

/** Общий пульс контурного свечения: от 0 до 1, у всех в такт, от часов сцены */
export const resolveActiveGlowShare = (now) => (Math.sin((now / ACTIVE_GLOW.pulseMs) * TWO_PI) + 1) / 2;

/** Прозрачность и множитель размера свечения в этот момент */
export const resolveActiveGlowPose = (now) => {
  const share = resolveActiveGlowShare(now);
  const {minAlpha, maxAlpha, minScale, maxScale} = ACTIVE_GLOW;
  return {
    alpha: minAlpha + (maxAlpha - minAlpha) * share,
    scale: minScale + (maxScale - minScale) * share,
  };
};

/**
 * Свечение активных отрядов: дышит вместе с флагами того же игрока. Спрайты
 * принадлежат отряду (двигаются и убираются с ним), здесь только их пульс.
 *
 * Свечение подчиняется контуру: контур прячут и мигают анимации отряда, и если бы
 * свечение жило само, оно осталось бы висеть без отряда.
 */
export default class ActiveUnitGlows {
  constructor(scene) {
    this.scene = scene;
    this.targets = new Set();
    this.isListening = false;
    this.tick = this.tick.bind(this);
  }

  /**
   * @param {Object} glow — спрайт свечения
   * @param {Object} outline — спрайт контура
   * @param {number} baseScale — масштаб свечения без пульса
   */
  add(glow, outline, baseScale) {
    const target = {glow, outline, baseScale};
    this.targets.add(target);
    this.updateTarget(target, resolveActiveGlowPose(this.scene?.time?.now ?? 0));
    if (!this.isListening && this.scene?.events?.on) {
      this.scene.events.on('update', this.tick);
      this.isListening = true;
    }
  }

  updateTarget({glow, outline, baseScale}, pose) {
    glow.setAlpha((outline.alpha ?? 1) * pose.alpha);
    glow.setScale(baseScale * pose.scale);
  }

  tick() {
    const pose = resolveActiveGlowPose(this.scene?.time?.now ?? 0);
    this.targets.forEach((target) => {
      if (target.glow.active === false || target.outline.active === false) {
        this.targets.delete(target);
        return;
      }
      this.updateTarget(target, pose);
    });
    if (this.targets.size === 0 && this.isListening) {
      this.scene?.events?.off?.('update', this.tick);
      this.isListening = false;
    }
  }

  /** Забыть все цели (разбор поля) */
  clear() {
    this.targets.clear();
    if (this.isListening) {
      this.scene?.events?.off?.('update', this.tick);
      this.isListening = false;
    }
  }
}
